<template>
    <div class="swift-wrapper__header">
        <div class="borrower-card">
          <div class="borrower-card__info">
            <div class="header-icon__wrapper">
              <span class="k-icon k-i-folder-open"></span>
            </div>
            <div class="borrower__info">
              <p class="borrower__info--loan-number">{{ loanNumber }}</p>
              <h1 class="borrower__info--borrower-name">{{ borrower }}</h1>
            </div>
          </div>
          <slot></slot>
        </div>
    </div>
</template>

<script>
    export default {
        name: 'ViewHeader',
        props:['loanNumber', 'borrower']
    }
</script>

<style>
  @import '/src/assets/css/viewHeader.css';
</style>